/* Stara Luxe theme scripts */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function withDelimiters(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      var parts = (n / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        default: return withDelimiters(cents, 2);
      }
    });
  }
  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;

  /* ---------- Header shadow ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('input[type=search], .drawer__close'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  window.theme.openDrawer = openDrawer;
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); if (opener.getAttribute('data-drawer-open') === 'CartDrawer') { refreshCart().then(function () { openDrawer('CartDrawer'); }); } else { openDrawer(opener.getAttribute('data-drawer-open')); } return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); closeWa(); }
  });

  /* ---------- Reveal on scroll ---------- */
  if (document.body.hasAttribute('data-no-animations')) document.documentElement.classList.add('no-animations');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach(function (el, i) { el.style.transitionDelay = (el.dataset.delay || 0) + 'ms'; io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); }

  /* ---------- Cart ---------- */
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function imgUrl(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    var body = $('#CartDrawerBody'), foot = $('#CartDrawerFoot');
    if (!body) return;
    var s = window.theme.strings || {};
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p class="h3">' + escapeHtml(s.empty || 'Your bag is empty') + '</p><a class="btn" href="/collections/all">Start shopping</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    var thr = Number(window.theme.freeShippingThreshold || 0) * 100;
    var bar = '';
    if (thr > 0) {
      var left = thr - cart.total_price, pct = Math.min(100, Math.round(cart.total_price / thr * 100));
      bar = '<div class="ship-bar"><span>' + (left > 0 ? 'You’re <strong>' + formatMoney(left) + '</strong> away from free delivery' : 'You’ve unlocked <strong>free delivery</strong>') + '</span><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
    }
    body.innerHTML = bar + cart.items.map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return escapeHtml(o.value); }).join(' · ');
      return '<div class="cart-item" data-key="' + escapeHtml(it.key) + '">' +
        '<a class="cart-item__img" href="' + escapeHtml(it.url) + '">' + (it.image ? '<img src="' + escapeHtml(imgUrl(it.image, 200)) + '" alt="' + escapeHtml(it.product_title) + '" loading="lazy" width="88" height="110">' : '') + '</a>' +
        '<div><a class="cart-item__title" href="' + escapeHtml(it.url) + '">' + escapeHtml(it.product_title) + '</a>' +
        (opts ? '<div class="cart-item__meta">' + opts + '</div>' : '') +
        '<div class="cart-item__row"><div class="qty"><button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-qty-input><button type="button" data-qty-change="1" aria-label="Increase quantity">+</button></div>' +
        '<strong>' + formatMoney(it.final_line_price) + '</strong></div>' +
        '<button type="button" class="cart-remove" data-remove>' + escapeHtml(s.remove || 'Remove') + '</button></div></div>';
    }).join('');
    var sub = $('#CartDrawerSubtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
  }
  function refreshCart() { return fetchJSON('/cart.js').then(function (c) { renderCart(c); return c; }).catch(function () {}); }
  window.theme.refreshCart = refreshCart;

  function changeLine(key, qty) {
    return fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) }).then(renderCart);
  }
  document.addEventListener('click', function (e) {
    var item = e.target.closest('#CartDrawer .cart-item'); if (!item) return;
    var key = item.getAttribute('data-key'), input = item.querySelector('[data-qty-input]');
    if (e.target.closest('[data-remove]')) { changeLine(key, 0); return; }
    var ch = e.target.closest('[data-qty-change]');
    if (ch) { var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(ch.getAttribute('data-qty-change'), 10)); changeLine(key, q); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('#CartDrawer [data-qty-input]')) { changeLine(e.target.closest('.cart-item').getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0)); }
  });

  function addToCart(id, qty, btn) {
    var s = window.theme.strings || {}, label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = s.adding || 'Adding…'; }
    return fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer('CartDrawer'); })
      .catch(function (err) { alertInline(btn, (err && (err.description || err.message)) || 'Could not add to cart'); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  function alertInline(btn, msg) {
    if (!btn) return;
    var p = btn.parentNode.querySelector('.form-error');
    if (!p) { p = document.createElement('p'); p.className = 'form-error errors'; p.setAttribute('role', 'alert'); btn.parentNode.appendChild(p); }
    p.textContent = msg;
  }

  // Quick add on cards
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault(); addToCart(q.getAttribute('data-quick-add'), 1, q);
  });

  /* ---------- Product form ---------- */
  $$('[data-product-form]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]'); if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var buyBtn = root.querySelector('[data-buy-now]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var qtyInput = root.querySelector('[data-product-qty]');
    var s = window.theme.strings || {};

    function selected() {
      return $$('.option', root).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      $$('.option', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
        });
        var legendVal = fs.querySelector('[data-selected-value]'); var c = fs.querySelector('input:checked');
        if (legendVal && c) legendVal.textContent = c.value;
      });
    }
    function update() {
      var opts = selected(), v = findVariant(opts);
      markAvailability(opts);
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = s.unavailable || 'Unavailable'; } if (buyBtn) buyBtn.disabled = true; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? (s.addToCart || 'Add to cart') : (s.soldOut || 'Sold out'); }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (v.featured_media) showMedia(String(v.featured_media.id));
      if (window.history && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.option')) update(); });

    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1, addBtn); });
    if (buyBtn) buyBtn.addEventListener('click', function (e) {
      e.preventDefault(); buyBtn.disabled = true;
      fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 }] }) })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { buyBtn.disabled = false; alertInline(buyBtn, (err && err.description) || 'Could not start checkout'); });
    });
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)); });
    });

    // Gallery
    var gallery = document.querySelector('[data-gallery]');
    function showMedia(mid) {
      if (!gallery) return;
      $$('.gallery__slide', gallery).forEach(function (sl) { sl.classList.toggle('is-active', sl.getAttribute('data-media-id') === mid); });
      $$('.gallery__thumb', gallery).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') === mid ? 'true' : 'false'); });
    }
    if (gallery) {
      gallery.addEventListener('click', function (e) { var t = e.target.closest('.gallery__thumb'); if (t) showMedia(t.getAttribute('data-media-id')); });
      var main = gallery.querySelector('.gallery__main'), startX = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (startX === null) return; var dx = e.changedTouches[0].clientX - startX; startX = null;
          if (Math.abs(dx) < 40) return;
          var slides = $$('.gallery__slide', gallery), i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
          var n = (i + (dx < 0 ? 1 : -1) + slides.length) % slides.length; showMedia(slides[n].getAttribute('data-media-id'));
        });
      }
    }
    markAvailability(selected());
  });

  /* ---------- Collection: sort + filters ---------- */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  });
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) { if (e.target.type === 'checkbox') form.submit(); });
  });
  $$('[data-filters-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { var w = $('.filters-wrap'); var open = w.classList.toggle('is-open'); b.setAttribute('aria-expanded', open); });
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), sx = el.querySelector('[data-s]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var days = Math.floor(diff / 864e5), hrs = Math.floor(diff % 864e5 / 36e5), mins = Math.floor(diff % 36e5 / 6e4), secs = Math.floor(diff % 6e4 / 1e3);
      if (d) d.textContent = pad(days); if (h) h.textContent = pad(hrs); if (m) m.textContent = pad(mins); if (sx) sx.textContent = pad(secs);
      if (diff === 0) clearInterval(t);
    }
    var t = setInterval(tick, 1000); tick();
  });

  /* ---------- WhatsApp pop-up ---------- */
  var wa = $('[data-wa-popup]');
  function closeWa() { if (wa) { wa.classList.remove('is-open'); try { sessionStorage.setItem('waPopupClosed', '1'); } catch (e) {} } }
  if (wa) {
    var seen = false; try { seen = sessionStorage.getItem('waPopupClosed') === '1'; } catch (e) {}
    if (!seen) setTimeout(function () { wa.classList.add('is-open'); }, (parseInt(wa.getAttribute('data-delay'), 10) || 6) * 1000);
    $$('[data-wa-close]').forEach(function (b) { b.addEventListener('click', closeWa); });
  }

    /* ---------- Product tabs + rail arrows ---------- */
  document.querySelectorAll('[data-tabs-section]').forEach(function (sec) {
    var tabs = sec.querySelectorAll('[data-tab]');
    function active() { return sec.querySelector('[data-rail]:not([hidden])'); }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        sec.querySelectorAll('[data-rail]').forEach(function (r) {
          var on = r.id === 'rail-' + t.getAttribute('data-tab');
          r.hidden = !on;
          if (on) r.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
        });
      });
    });
    function scrollBy(dir) { var r = active(); if (r) r.scrollBy({ left: dir * r.clientWidth * 0.8, behavior: 'smooth' }); }
    var prev = sec.querySelector('[data-rail-prev]'), next = sec.querySelector('[data-rail-next]');
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  });

  /* ---------- Wishlist hearts (saved per browser) ---------- */
  var wishKey = 'stara_wish', wish = [];
  try { wish = JSON.parse(localStorage.getItem(wishKey) || '[]'); } catch (e) { wish = []; }
  document.querySelectorAll('[data-wish]').forEach(function (b) {
    if (wish.indexOf(b.getAttribute('data-wish')) > -1) b.classList.add('is-on');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), i = wish.indexOf(h);
    if (i > -1) { wish.splice(i, 1); b.classList.remove('is-on'); } else { wish.push(h); b.classList.add('is-on'); }
    try { localStorage.setItem(wishKey, JSON.stringify(wish)); } catch (e2) {}
  });

  /* ---------- Init cart count ---------- */
  refreshCart();
})();
